/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
//css
import styles from './SearchGroup.module.scss'

// components
import SearchBar from './components/searchBar'
import GroupsList from './components/groupsList'
import { Typography } from '@mui/material'

// actions
import { resetFilteredGroups } from '../../store/reducers/groupsSlice'

// hooks
import useGroups from '../../hooks/useGroups'
import Breadcrumbs from '../../components/Breadcrumbs'

const SearchGroup = () => {
  const [searchText, setSearchText] = useState('')
  const { groups, getGroups, areGroupsLoading } = useGroups()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  useEffect(() => {
    if (searchText?.length < 2) {
      dispatch(resetFilteredGroups())
    }
  }, [searchText])

  return (
    <div style={{ height: '90vh' }}>
      <div
        className={styles.stickyHeader}
        style={{
          backgroundColor: '#F5F5F5',
          width: '100vw',
          padding: '20px',
        }}
      >
        <Breadcrumbs
          className={styles.stickyHeader}
          value={'Group / View & Edit'}
        />
        
        <h1 className={styles.header}>{t("view-edit-group")}</h1>

        <Typography
          variant="h6"
          style={{
              fontSize: '16px',
              fontFamily: 'Johnson Text',
              marginLeft: '80px',
              marginRight: '80px',
              paddingBottom: '8px',
              fontWeight: 700,
              fontStyle: 'Medium',
              leadingTrim: 'NONE',
              letterSpacing: '0%',
            }}
          >{t("view-edit-group-eyebrow")}
        </Typography>

        <SearchBar
          searchText={searchText}
          setSearchText={setSearchText}
          getGroups={getGroups}
        />
      </div>
      {searchText.length >= 1 && (
        <>
        <div className={styles['group-tips-container']}>
            <div className={styles['group-tips-content']}>
              <span className={styles['group-tips-title']}>{t("search-tip-group-detail")}</span>
            </div>
          </div>
        <GroupsList groups={groups} areGroupsLoading={areGroupsLoading} />
        </>
      )}
    </div>
  )
}

export default SearchGroup
